// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_WATCHDOG_SUBSCRIBE = "ulo\u017eenie h\u013eadania";
export const BAZAAR_WATCHDOG_CANCELED = "Ulo\u017een\u00e9 h\u013eadanie bolo zru\u0161en\u00e9.";
export const BAZAAR_WATCHDOG_SAVED = "H\u013eadanie bolo \u00faspe\u0161ne ulo\u017een\u00e9.";
export const PAGE_SLUG = "strana";
